import * as React from 'react';

interface IState {
  successParameter: string;
}

export default class SuccessFeedback extends React.Component<{}, IState> {
  constructor(props: {}) {
    super(props);

    this.state = {
      successParameter: '',
    };
  }

  componentDidMount = () => {
    this.getQueryParamter();
  };

  getQueryParamter = (): void => {
    const currentUrl: string = window.location.href;
    const successParameter: string = currentUrl.split('?')[1];
    this.setState({ successParameter });
  };

  renderSucessFeedback = () => {
    return (
      <div className="success-feedback">
        <h2 className="title">Takk for henvendelsen</h2>
        <p className="text">Vi tar kontakt med deg snarest.</p>
      </div>
    );
  };

  render = () => {
    const { successParameter } = this.state;
    if (successParameter === 'success') {
      return this.renderSucessFeedback();
    }
    return this.props.children;
  };
}
